import { StateWishlist } from '@spa/lib/store/wishlists/WishlistsState';
import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import { createAction } from '@reduxjs/toolkit';

export interface ApiGetMyWishlistsRequestedPayload {
  readonly actionId: number;
  readonly parentActionId: number;
}

export const apiGetMyWishlistsRequestedType = 'api/wishlist/getMyWishlists--requested';
export const apiGetMyWishlistsRequested = createAction<ApiGetMyWishlistsRequestedPayload>(
  apiGetMyWishlistsRequestedType
);
export type ApiGetMyWishlistsRequestedAction = ReturnType<typeof apiGetMyWishlistsRequested>;

export interface ApiGetMyWishlistsSucceededPayload {
  readonly parentActionId: number;
  readonly requestedActionId: number;
  readonly result: ReadonlyArray<StateWishlist>;
}

export const apiGetMyWishlistsSucceededType = 'api/wishlist/getMyWishlists--succeeded';
export const apiGetMyWishlistsSucceeded = createAction<
  ApiGetMyWishlistsSucceededPayload,
  typeof apiGetMyWishlistsSucceededType
>(apiGetMyWishlistsSucceededType);
export type ApiGetMyWishlistsSucceededAction = ReturnType<typeof apiGetMyWishlistsSucceeded>;

export interface ApiGetMyWishlistsFailedPayload {
  readonly parentActionId: number;
  readonly requestedActionId: number;
  readonly error: WishlistError;
}

export const apiGetMyWishlistsFailedType = 'api/wishlist/getMyWishlists--failed';
export const apiGetMyWishlistsFailed = createAction<
  ApiGetMyWishlistsFailedPayload,
  typeof apiGetMyWishlistsFailedType
>(apiGetMyWishlistsFailedType);
export type ApiGetMyWishlistsFailedAction = ReturnType<typeof apiGetMyWishlistsFailed>;
